import { Sparkles } from 'lucide-react';

const NewBadge = ({ createdAt, daysThreshold = 14 }) => {
  if (!createdAt) return null;

  const created = new Date(createdAt);
  const now = new Date();
  const daysDiff = Math.floor((now - created) / (1000 * 60 * 60 * 24));

  if (daysDiff > daysThreshold) return null;

  return (
    <span 
      className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-green-100 text-green-700 rounded-full"
      data-testid="new-badge"
    >
      <Sparkles className="w-3 h-3" />
      New
    </span>
  );
};

export default NewBadge;
